import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfIcon from '@elem/ui/ef-icon';
import EfSpec from '@elem/ui/ef-spec';
import EfTabSection from '@elem/ui/ef-tab-section';
import styles from './index.module.scss';
import { getIsPadWidth } from '@elem/utils/devices';
import { useState, useEffect } from 'react';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const initListA = [
        {
            tabName: t('b_tab'),
            bottomContent: t('b_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571122673/tabA_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571512584/tabA_2_h5.jpg',
        },
        {
            tabName: t('c_tab'),
            bottomContent: t('c_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724570980942/tabA_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571512958/tabA_3_h5.jpg',
        },
        {
            tabName: t('d_tab'),
            bottomContent: t('d_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724570980763/tabA_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571513142/tabA_4_h5.jpg',
        },
    ];
    const init_pc = [
        {
            tabName: t('a_tab'),
            bottomContent: t('a_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724570980217/tabA_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571512782/tabA_1_h5.jpg',
            fixedElement: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724659007935/x_stream_icon.png" />,
        },
    ];
    const init_h5 = [
        {
            tabName: t('a_tab'),
            bottomContent: t('a_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724570980217/tabA_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571512782/tabA_1_h5.jpg',
            fixedElement: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724659727978/x_stream_icon_light.png" />,
        },
    ];

    const [list, setList] = useState<any>([...init_pc, ...initListA]);

    useEffect(() => {
        const isMobile = getIsPadWidth();

        if (!!isMobile) {
            setList([...init_h5, ...initListA]);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            <EfTabSection list={list} type="LROpacity" />
            <EfSpec />
        </div>
    );
}
